import Raven from 'raven-js';
if(window.env === "beatfit-dev") {
  Raven.config('https://e27fb00bfa0d45d293e1249b14d22333@o196264.ingest.sentry.io/1302717').install();
} else {
  Raven.config('https://b9ff972beba643c7b56ea98b1b2a9c37@sentry.io/1307864').install();
}
window.Raven = Raven

// エラー表示
function error(message, log, option) {
  UIkit.notification(message, { status: 'danger' })
  console.error(JSON.stringify(log))
  Raven.captureMessage(message)
  passiveLoading()
}
window.error = error

// ワーニング表示
function warning(message, log, option) {
  UIkit.notification(message, { status: 'warning' })
  console.warn(JSON.stringify(log))
  Raven.captureMessage(message)
  passiveLoading()
}
window.warning = warning

// 想定外のexceptionを捉える
// 想定外のエラー捕捉
window.onerror = function(message, file, line, col, error){
  Raven.captureException(error);
}
